import { get } from 'lodash';

export function formatAccountDisplayText(account) { //destination accounts data is labeled with capitals slightly differently from original accounts list data labels. Need to make the same.
  const accountNumber = get(account, 'accountNumber', '').toString();
  return `${get(account, 'beneficiary.name', '').toUpperCase()} ...${accountNumber.substring(accountNumber.length - 5)}`;
}
